import React, { useState } from 'react';
import { ProductVariant } from '@zonofi/zono-money-store';
import { Switcher } from '../../components';
import { isNull } from 'lodash';

interface StockToggleProps {
  product: ProductVariant;
  toggleProductAvaiablity?: (product: ProductVariant) => Promise<boolean>;
}

export const StockToggle: React.FC<StockToggleProps> = ({
  product,
  toggleProductAvaiablity,
}) => {
  const [stock, setStock] = useState((product?.stock ?? 0) > 0);

  const onToggle = async () => {
    const isSuccess = await toggleProductAvaiablity?.(product);
    if (isSuccess) setStock((prev) => !prev);
  };

  return (
    <div className="product-card-stock">
      <span className="product-card-stock-text font-regular">{`Stock ${
        stock && !isNull(product.stock) ? 'In' : 'Out'
      }`}</span>
      <Switcher
        checked={stock}
        onChange={onToggle}
        switcherStyles={{
          noSelectBg: '#f0f0f0',
          thumbColor: stock ? '#ffffff' : '#8C8C8C',
          switchSize: { width: 64, height: 36 },
          thumbSize: { width: 30, height: 30 },
          checkedTransform: 'translateX(30px)',
        }}
      />
    </div>
  );
};
